import { Vue, Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
class LightboxCarousel extends Vue {
    public lightboxOpen = false;

    @Getter("getLightboxData") public data!: any[];

    @Watch("data")
    public watchData() {
        this.lightboxOpen = true;
        document.documentElement.classList.add("is-not-scrollable");
    }

    public closeLightbox() {
        this.lightboxOpen = false;
        document.documentElement.classList.remove("is-not-scrollable");
    }
}

export default LightboxCarousel;
